export class UBSCreatePatientRequest {
    public name: string = '';
    public motherName: string = '';
    public cpf: string = '';
    public cns: string = '';
    public birthDate: Date | null = null;
    public idGender: number | null = null;
    public optIn: boolean = false;
    public url: string = '';
    public token: string = '';
}